import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HomeLineChartComponent } from './home-line-chart.component';
import { BrowserModule } from '@angular/platform-browser';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';

@NgModule({
    imports: [
        BrowserModule,
        CommonModule
    ],
    declarations: [
        HomeLineChartComponent
    ],
    providers: [
        UtilitiesService,
    ],
    exports: [
        HomeLineChartComponent,
    ]
})
export class HomeLineChartModule {}